module.exports = __webpack_public_path__ + "static/media/view award category.6deec6e3.svg";